import React, { useState, useEffect } from "react";
import withLanguageContext from "lib/hocs/withLanguageContext";
import Cookies from "js-cookie";
import config from "lib/config";
import { ThemeProvider } from "@mui/material/styles";
import theme from "lib/themes/theme";
import Alert from "Components/Fragment/Alert";
import * as constants from "./constants";
import { Link, Typography } from "@mui/material";

const CookieConsent = ({ languageContext }) => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    setOpen(!Cookies.get(constants.COOKIES_ACCEPT));
  }, []);

  const handleCookieClick = (consentType) => {
    Cookies.set(consentType, constants.COOKIE_CONSENT_VALUE, { expires: 365 });
    setOpen(false);
  };

  const alertText = (
    <Typography variant="body">
      {languageContext("cookieConsentModalText")}
      <br />
      <Link
        href={`${config.urlRoot}np/cookieInfo.aspx`}
        color="inherit"
        underline="always"
        target="_blank"
        rel="noopener noreferrer"
      >
        {languageContext("readMoreCookies")}
      </Link>
    </Typography>
  );

  return (
    <ThemeProvider theme={theme}>
      <Alert
        handleConfirm={() => handleCookieClick(constants.COOKIES_ACCEPT)}
        confirmText={languageContext("accept")}
        open={open}
        title={languageContext("cookieConsentModalTitle")}
        text={alertText}
      />
    </ThemeProvider>
  );
};

export default withLanguageContext(CookieConsent, "Common");
